import { createContext, useCallback, useContext, useEffect, useState } from "react";

// Lightweight client-side i18n for the footer + /about + home strip. English is the default (crawler-visible) language.
// v2 key: values written by the earlier Greek-default build (key "wstf_lang", auto-saved on every visit) are discarded.
const KEY = "wstf_lang_v2";
const LEGACY_KEYS = ["wstf_lang"];
const LANGS = ["el", "en"];
const LangCtx = createContext({ lang: "en", setLang: () => {} });

function initialLang() {
  LEGACY_KEYS.forEach((k) => window.localStorage.removeItem(k));
  const saved = window.localStorage.getItem(KEY);
  return LANGS.includes(saved) ? saved : "en";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  // Persist only an explicit visitor choice, so a future default change can never be overridden by an auto-saved value.
  const setLang = useCallback((next) => {
    window.localStorage.setItem(KEY, next);
    setLangState(next);
  }, []);
  return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
